<template>
  <div ref="container" class="cms" />
</template>

<script>
import preset, { enumStyleFormat } from '@mc/tangram-preset-h5'
import { baichuanAdapter } from '@/common/cms/adapters/baichuan'
import EventBus from '@mc/mc-utils/js/event_bus/event_bus'


import { Coupons } from '@/common/cms/modules/coupons/module'
import { Goods } from '@/common/cms/modules/goods/module'
import { HotSpot } from '@/common/cms/modules/hotspot/module'
import { Video } from '@/common/cms/modules/video/module'
import { Seckill } from '@/common/cms/modules/seckill/moudle'
import { Anchor } from '@mc/tangram-module-anchor'
import { RichText } from '@mc/tangram-module-rich-text'
import { Popup } from '@mc/tangram-module-popup'
import { templateCouponsVue } from '@/common/cms/modules/coupons/template'
import { templateGoodsVue } from '@/common/cms/modules/goods/template'
import { templateHotSpotVue } from '@/common/cms/modules/hotspot/template'
import { templateVideoVue } from '@/common/cms/modules/video/template'
import { templateSeckillVue } from '@/common/cms/modules/seckill/template'
import { templateAnchorVue } from '@mc/tangram-template-anchor-vue'
import { templateRichTextVue } from '@mc/tangram-template-rich-text-vue'
import { templatePopupVue } from '@mc/tangram-template-popup-vue'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import { cmsRedirect } from '@/common/cms/cms_redirect'
import { checkWebp } from '@/utils/check_webp'
import { trackRoutesMap } from '@/utils/tracer/routes_map'

export default {
  name: 'CMS',
  async created() {
    const webp = await checkWebp()
    // 这个 cms 实例就是为了保存一下用的方便，不需要响应式，所以不用 $set
    this.cms = preset({
      baseWidth: window.innerWidth * 2,
      expectFormat: enumStyleFormat.CamelCase,
      adapters: [baichuanAdapter],
      webp,
      useExposeTrack: true,
      expose: { 
        callback: target => {
          if ((target?.data?.click || target?.data?.goods) && target?.data?.data) {
            const spm = target.data?.click?.spm || target.data?.goods?.spm
            const dataParams = target.data?.click?.spmJson || target.data?.goods?.spmJson 
            const extraTrack = target.data?.extraTrack || {}
            const params = Object.assign(
              {},
              dataParams,
              target.data.data,
              extraTrack
            )
            tracerVuePlugin.request({
              spm,
              type: 8,
              params,
              page_id: trackRoutesMap['#/cms/:cms_id'].pageId
            })
          }
        }
      }
    })
    this.cms.addModule({
      module: Popup,
      moduleName: 'popup',
      template: templatePopupVue,
      renderIdentifier: 'popup'
    })
    this.cms.addModule({
      module: Anchor,
      moduleName: 'anchor_point',
      template: templateAnchorVue,
      renderIdentifier: 'anchor'
    })
    this.cms.addModule({
      module: RichText,
      moduleName: 'rich_text',
      template: templateRichTextVue,
      renderIdentifier: 'rich-text'
    })
    this.cms.addModule({
      module: Coupons,
      moduleName: 'coupons',
      template: templateCouponsVue,
      renderIdentifier: 'coupons'
    })
    this.cms.addModule({
      module: Goods,
      moduleName: 'goods',
      template: templateGoodsVue,
      renderIdentifier: 'goods'
    })
    this.cms.addModule({
      module: HotSpot,
      moduleName: 'img_hotspot',
      template: templateHotSpotVue,
      renderIdentifier: 'img-hotspot'
    })
    this.cms.addModule({
      module: Video,
      moduleName: 'mc_cms_video',
      template: templateVideoVue,
      renderIdentifier: 'video'
    })
    this.cms.addModule({
      module: Seckill,
      moduleName: 'seckill',
      template: templateSeckillVue,
      renderIdentifier: 'seckill'
    })
    this.cms.addEventListener(this.cms.instance.Events.REDIRECT, evt => {
      cmsRedirect(evt)
    })
    EventBus.dispatch('cmsInstanceReady')
  },
  beforeDestroy() {
    EventBus.removeEventListener('cmsInstanceReady')
  },
  methods: {
    hasModule(code, data) {
      const { page_data = [] } = data || {}
      return !!page_data.find(module => module.code === code)
    },
    async loadLottery() {
      if (!this.lotteryLoaded) {
        try {
          const m = await import(/* webpackChunkName: "cms-module-lottery" */ './async_lottery')
          const {
            Lottery,
            templateSlotMachineVue,
            templateSudokuMachineVue,
            LotteryList,
            templateLotteryListVue,
            templateCouponLotteryVue
          } = m
          this.cms.addModule({
            module: LotteryList,
            moduleName: 'lottery_list',
            templates: [
              {
                renderIdentifier: 'lottery_list',
                template: templateLotteryListVue
              },
              {
                renderIdentifier: 'coupon_lottery',
                template: templateCouponLotteryVue
              }
            ]
          })
          this.cms.addModule({
            module: Lottery,
            moduleName: 'lottery',
            templates: [
              {
                renderIdentifier: 'slot_machine',
                template: templateSlotMachineVue
              },
              {
                renderIdentifier: 'sudoku_machine',
                template: templateSudokuMachineVue
              }
            ]
          })
         
         this.lotteryLoaded = true
        } catch (error) {}
      }
    },
    async loadPhaseOperations() {
     
      if (!this.phaseOperationsLoaded) {
        try {
          const m = await import(/* webpackChunkName: "cms-module-phase-operations" */ './async_phase_operations')
          const {
            PhaseOperations,
            templatePhaseOperationsVue,
            templatePhaseOperationsComplexVue,
            templatePhaseOperationsSimplexVue
          } = m
          this.cms.addModule({
            module: PhaseOperations,
            moduleName: 'phase_operations',
            templates: [
              {
                renderIdentifier: 'phase_operations',
                template: templatePhaseOperationsVue
              },
              {
                renderIdentifier: 'phase_operations_complex',
                template: templatePhaseOperationsComplexVue
              },
              {
                renderIdentifier: 'phase_operations_simple',
                template: templatePhaseOperationsSimplexVue
              }
            ]
          })
          this.phaseOperationsLoaded = true
        } catch (error) {}
      }
    },
    async render(data) {
      if (
        this.hasModule('lottery', data) ||
        this.hasModule('lottery_list', data)
      ) {
        await this.loadLottery()
      }
      if (this.hasModule('phase_operations', data)) {
        await this.loadPhaseOperations()
      }

      const renderCms = () => {
        this.cms.setData(data)
        this.cms.render(this.$refs.container)
      }
      if (this.cms) {
        renderCms()
      } else {
        EventBus.addEventListener('cmsInstanceReady', renderCms)
      }

    }
  }
}
</script>